import styled from 'styled-components';

export const ScEmailConfirmPopup = styled.div`
  position: fixed;
  inset: 0 0 auto;
  background-color: ${({ theme }) => theme.whiteColor};
  color: ${({ theme }) => theme.blackColor};
  min-height: 32px;
  padding: 6px 0;
  z-index: 100;

  & > div {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;

    .text {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;

      & > .link {
        letter-spacing: 0.14px;
        color: ${({ theme }) => theme.secondaryColor};
        text-decoration-line: underline;
        margin-left: 4px;
        font-weight: 700;
        cursor: pointer;
      }
    }
  }
`;
